import { ChangeDetectorRef, OnDestroy, OnInit, Pipe, PipeTransform } from '@angular/core';

import { Subscription } from 'rxjs';

// import { LanguageEnum, LanguageService } from '@shared/services';
import _ from 'lodash';

import { LanguageEnum } from '@api';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';

import { InitialNameService } from '@shared/service/initial-name.service';

import { CoreTranslateService } from 'pn-core-code';

@Pipe({
  name: 'translations',
  pure: false,
  standalone: true,
})
export class TranslationsPipe implements PipeTransform, OnDestroy {

  currentLang: string;

  private changes$$: Subscription;

  constructor(
    private translateService: TranslateService,
  ) {
    this.translateService.onLangChange.subscribe(t => {
      this.currentLang = t.lang;
    });
  }


  transform(value: any, attr: string = 'title', languageAttr?: string,  isShowDash: boolean = false): string | any {
    this.currentLang = this.translateService.currentLang;
    // console.log('this.currentLang', this.currentLang);
    // console.log('languageAttr', languageAttr)
    if (_.isArray(value) && value.length > 0 && attr) {
      let resultObject = _.find(value, v => v.language === (languageAttr || this.currentLang || LanguageEnum.Th))
      // console.log('resultObject-->', resultObject)
      if (attr && _.has(resultObject, attr)) {
        return resultObject[attr] || null
      } else {
        return isShowDash ? "-" : undefined;
      }
    } else if (_.isArray(value) && value.length === 0) {
      return "-" ;
    } else {

      return value[attr] || null
    }


  }

  ngOnDestroy() {
    if (this.changes$$) {
      this.changes$$.unsubscribe();
    }
  }

}
